import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const Container = styled.div`
  ${tw`flex flex-col gap-2 font-medium text-15-20 text-grey-dark-40`}
`;
